import { useState } from "react";

import { Popover } from "antd";

import { ToolbarButton } from "components/base";
import { Icon_ThreeDGeoModel } from "components/icons";

import { useXdaSettingsStore } from "../../context";
import { selectShowIpdb } from "../../context/xdaSettingsSelectors";
import Xda3DGeoOptions from "./Xda3DGeoOptions";

interface Xda3DGeoToggleProps {
  binUpdateErrorMessage: string;
}

function Xda3DGeoToggle({ binUpdateErrorMessage }: Xda3DGeoToggleProps) {
  const showIpdb = useXdaSettingsStore(selectShowIpdb);
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={<Xda3DGeoOptions binUpdateErrorMessage={binUpdateErrorMessage} />}
      trigger="click"
      placement="bottomRight"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        isMenuButton={true}
        icon={<Icon_ThreeDGeoModel />}
        active={showIpdb}
        tooltipText={"3D Geo Model"}
        overflowLabel={"3D Geo Model"}
        styleKey="xdaToolbar"
      />
    </Popover>
  );
}

export default Xda3DGeoToggle;
